module.exports = __webpack_public_path__ + "img/check-teal.77b976ca.svg";